import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'
import { useBrand } from '../../context/BrandContext'

const spaces = [
  {
    id: 'obhr160', group: 'On-Campus Housing', name: '160 OBHR', type: 'housing',
    capacity: 5, amenities: ['Private Bath', 'Kitchen', 'WiFi'],
    rooms: [{ id: 'obhr160', name: '160 OBHR', beds: 5 }]
  },
  {
    id: 'obhr164', group: 'On-Campus Housing', name: '164 OBHR', type: 'housing',
    capacity: 3, amenities: ['Shared Bath', 'Kitchen', 'WiFi'],
    rooms: [{ id: 'obhr164', name: '164 OBHR', beds: 3 }]
  },
  {
    id: 'bevelander', group: 'Cottages', name: 'Bevelander Cottage', type: 'housing',
    capacity: 3, amenities: ['Private Rooms', 'Shared Bath', 'Kitchen', 'WiFi'],
    rooms: [
      { id: 'bev1', name: 'Bevelander 1', beds: 1 },
      { id: 'bev2', name: 'Bevelander 2', beds: 1 },
      { id: 'bev3', name: 'Bevelander 3', beds: 1 },
    ]
  },
  {
    id: 'emery', group: 'Dormitories', name: 'Emery Dorm', type: 'housing',
    capacity: 6, amenities: ['Single Rooms', 'Shared Bath', 'Common Room', 'WiFi'],
    rooms: [
      { id: 'emery1',  name: 'Emery 1',  beds: 1 },
      { id: 'emery2a', name: 'Emery 2A', beds: 1 },
      { id: 'emery3a', name: 'Emery 3A — Community Room', beds: 0, isCommon: true },
      { id: 'emery4a', name: 'Emery 4A', beds: 1 },
      { id: 'emery5a', name: 'Emery 5A', beds: 1 },
      { id: 'emery6a', name: 'Emery 6A', beds: 1 },
    ]
  },
  {
    id: 'birch', group: 'Dormitories', name: 'Birch Dorm', type: 'housing',
    capacity: 16, amenities: ['Multi-Bed Rooms', 'Shared Bath', 'Study Lounge', 'WiFi'],
    rooms: [{ id: 'birch', name: 'Birch Dorm', beds: 16 }]
  },
  {
    id: 'eden', group: 'Cottages', name: 'Eden Cottage', type: 'housing',
    capacity: 1, amenities: ['Private Room', 'Private Bath', 'Kitchen', 'WiFi'],
    rooms: [{ id: 'eden', name: 'Eden Cottage', beds: 1 }]
  },
  {
    id: 'oakes', group: 'Dormitories', name: 'Oakes Dorm', type: 'housing',
    capacity: 6, amenities: ['Single Rooms', 'Shared Bath', 'WiFi'],
    rooms: [{ id: 'oakes', name: 'Oakes Dorm', beds: 6 }]
  },
  {
    id: 'conf_a', group: 'Conference Rooms', name: 'Conference Room A', type: 'conference',
    capacity: 20, amenities: ['Projector', 'Whiteboard', 'Video Conferencing', 'WiFi'],
    rooms: [{ id: 'conf_a', name: 'Conference Room A', beds: 0 }]
  },
  {
    id: 'conf_b', group: 'Conference Rooms', name: 'Conference Room B', type: 'conference',
    capacity: 8, amenities: ['TV Screen', 'Whiteboard', 'WiFi'],
    rooms: [{ id: 'conf_b', name: 'Conference Room B', beds: 0 }]
  },
  {
    id: 'dining', group: 'Dining', name: 'Dining Hall', type: 'dining',
    capacity: 60, amenities: ['Full Catering', 'AV Equipment', 'Event Setup'],
    rooms: [{ id: 'dining', name: 'Dining Hall', beds: 0 }]
  },
]

const typeIcon = { housing: '🏠', conference: '📋', dining: '🍽️' }
const typeColor = { housing: '#2A9D8F', conference: '#4A6B8A', dining: '#B8734A' }

const guestTypes = [
  'Visiting Scientist', 'Graduate Student', 'Student Fellowship',
  'AmeriCorps Volunteer', 'Seminar Speaker', 'Short Term Collaborator',
  'Recruitment Candidate', 'Development Guest', 'Other'
]

export default function EmpCampus() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const { brand } = useBrand()
  const label = brand.campusLabel || 'Collective Campus'

  const [view, setView] = useState('browse')
  const [selectedSpace, setSelectedSpace] = useState(null)
  const [filterType, setFilterType] = useState('all')
  const [submitted, setSubmitted] = useState(false)
  const [form, setForm] = useState({
    guestFirst: '', guestLast: '', guestEmail: '', guestType: '',
    gender: '', hasPets: false, address: '', city: '', state: '', country: 'USA',
    purpose: '', notes: '', arrivalDate: '', departureDate: '', billTo: '',
    spaceId: '', roomId: '',
  })

  const filtered = spaces.filter(s => filterType === 'all' || s.type === filterType)
  const groups = [...new Set(filtered.map(s => s.group))]

  function selectAndRequest(space) {
    setSelectedSpace(space)
    setForm(f => ({ ...f, spaceId: space.id, roomId: space.rooms[0]?.id || '' }))
    setView('request')
  }

  function handleSubmit() {
    setSubmitted(true)
    setTimeout(() => { setSubmitted(false); setView('browse') }, 4000)
  }

  const nights = form.arrivalDate && form.departureDate
    ? Math.max(0, (new Date(form.departureDate) - new Date(form.arrivalDate)) / 86400000)
    : 0

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>
      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:10}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>{label}</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Browse available spaces and submit booking requests</p>
        </div>
        <div style={{display:'flex',gap:8}}>
          {['browse','request'].map(v => (
            <button key={v} onClick={() => setView(v)}
              style={{padding:'7px 16px',border:`1px solid ${view===v?accent:'#EDE6DA'}`,borderRadius:6,background:view===v?accent:'#fff',color:view===v?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",textTransform:'capitalize'}}>
              {v === 'browse' ? '🏘 Browse Spaces' : '📝 New Request'}
            </button>
          ))}
        </div>
      </div>

      {view === 'browse' && (
        <>
          {/* Filter tabs */}
          <div style={{display:'flex',gap:8,marginBottom:16,flexWrap:'wrap'}}>
            {[['all','All Spaces'],['housing','Housing'],['conference','Conference'],['dining','Dining']].map(([val,label]) => (
              <button key={val} onClick={() => setFilterType(val)}
                style={{padding:'6px 14px',border:`1px solid ${filterType===val?accent:'#EDE6DA'}`,borderRadius:20,background:filterType===val?accent+'15':'#fff',color:filterType===val?accent:'#6B7D6B',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                {label}
              </button>
            ))}
          </div>

          {groups.map(group => (
            <div key={group} style={{marginBottom:20}}>
              <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.12em',color:'#6B7D6B',fontWeight:600,marginBottom:10,paddingLeft:2}}>{group}</div>
              <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12}}>
                {filtered.filter(s => s.group === group).map(space => (
                  <div key={space.id} style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:12,overflow:'hidden',transition:'all 0.2s'}}
                    onMouseEnter={e => { e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow='0 8px 24px rgba(43,43,43,0.08)' }}
                    onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='none' }}>
                    <div style={{height:6,background:typeColor[space.type]}}/>
                    <div style={{padding:'14px'}}>
                      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
                        <div>
                          <div style={{fontFamily:'Georgia,serif',fontSize:14,fontWeight:600,color:'#2B2B2B'}}>{space.name}</div>
                          <div style={{fontSize:10,color:typeColor[space.type],fontWeight:600,textTransform:'uppercase',letterSpacing:'0.08em',marginTop:2}}>{typeIcon[space.type]} {space.type}</div>
                        </div>
                        <div style={{textAlign:'right'}}>
                          <div style={{fontFamily:'Georgia,serif',fontSize:18,color:accent,fontWeight:700}}>{space.capacity}</div>
                          <div style={{fontSize:9,color:'#8A9E8A'}}>capacity</div>
                        </div>
                      </div>
                      <div style={{display:'flex',flexWrap:'wrap',gap:4,marginBottom:12}}>
                        {space.amenities.map(a => (
                          <span key={a} style={{fontSize:9,padding:'2px 7px',borderRadius:10,background:'#F7F2EB',color:'#6B7D6B',fontWeight:500}}>{a}</span>
                        ))}
                      </div>
                      {space.rooms.length > 1 && (
                        <div style={{fontSize:11,color:'#8A9E8A',marginBottom:10}}>{space.rooms.length} rooms available</div>
                      )}
                      <button onClick={() => selectAndRequest(space)}
                        style={{width:'100%',padding:'8px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                        Request Booking →
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </>
      )}

      {view === 'request' && (
        <div style={{display:'grid',gridTemplateColumns:'1fr 320px',gap:16}}>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'14px 18px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Booking Request</div>
              <button onClick={() => setView('browse')} style={{background:'none',border:'none',fontSize:11,color:'#8A9E8A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>← Back to Spaces</button>
            </div>

            {submitted ? (
              <div style={{padding:'3rem',textAlign:'center'}}>
                <div style={{fontSize:48,marginBottom:16}}>✅</div>
                <div style={{fontFamily:'Georgia,serif',fontSize:'1.3rem',color:'#2B2B2B',marginBottom:8}}>Request Submitted!</div>
                <div style={{fontSize:13,color:'#6B7D6B',lineHeight:1.8}}>Campus Services will review your request and confirm or decline based on availability. You'll be notified once a decision is made.</div>
              </div>
            ) : (
              <div style={{padding:'18px',display:'flex',flexDirection:'column',gap:16}}>

                {/* Space selector */}
                <div>
                  <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:8}}>Space</label>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
                    <select value={form.spaceId} onChange={e => {
                      const s = spaces.find(sp => sp.id === e.target.value)
                      setForm(f => ({ ...f, spaceId: e.target.value, roomId: s?.rooms[0]?.id || '' }))
                      setSelectedSpace(s)
                    }} style={{padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}>
                      <option value="">Select a space...</option>
                      {spaces.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                    </select>
                    {selectedSpace && selectedSpace.rooms.length > 1 && (
                      <select value={form.roomId} onChange={e => setForm(f => ({ ...f, roomId: e.target.value }))}
                        style={{padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}>
                        {selectedSpace.rooms.filter(r => !r.isCommon).map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
                      </select>
                    )}
                  </div>
                </div>

                {/* Dates */}
                <div>
                  <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:8}}>Dates</label>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                    <div>
                      <div style={{fontSize:10,color:'#8A9E8A',marginBottom:4}}>Arrival Date</div>
                      <input type="date" value={form.arrivalDate} onChange={e => setForm(f => ({ ...f, arrivalDate: e.target.value }))}
                        style={{width:'100%',padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}/>
                    </div>
                    <div>
                      <div style={{fontSize:10,color:'#8A9E8A',marginBottom:4}}>Departure Date</div>
                      <input type="date" value={form.departureDate} onChange={e => setForm(f => ({ ...f, departureDate: e.target.value }))}
                        style={{width:'100%',padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}/>
                    </div>
                  </div>
                  {nights > 0 && (
                    <div style={{fontSize:11,color:accent,fontWeight:600,marginTop:6}}>{nights} night{nights !== 1 ? 's' : ''}</div>
                  )}
                </div>

                {/* Guest info */}
                <div>
                  <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:8}}>Guest Information</label>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                    {[
                      ['First Name','guestFirst','text'],
                      ['Last Name','guestLast','text'],
                      ['Email','guestEmail','email'],
                      ['Country','country','text'],
                    ].map(([label, key, type]) => (
                      <div key={key}>
                        <div style={{fontSize:10,color:'#8A9E8A',marginBottom:4}}>{label}</div>
                        <input type={type} value={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                          style={{width:'100%',padding:'8px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}/>
                      </div>
                    ))}
                    <div>
                      <div style={{fontSize:10,color:'#8A9E8A',marginBottom:4}}>Guest Type</div>
                      <select value={form.guestType} onChange={e => setForm(f => ({ ...f, guestType: e.target.value }))}
                        style={{width:'100%',padding:'8px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}>
                        <option value="">Select...</option>
                        {guestTypes.map(g => <option key={g}>{g}</option>)}
                      </select>
                    </div>
                    <div>
                      <div style={{fontSize:10,color:'#8A9E8A',marginBottom:4}}>Gender</div>
                      <select value={form.gender} onChange={e => setForm(f => ({ ...f, gender: e.target.value }))}
                        style={{width:'100%',padding:'8px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}>
                        <option value="">Select...</option>
                        {['Male','Female','Non-binary','Prefer not to say'].map(g => <option key={g}>{g}</option>)}
                      </select>
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:8,paddingTop:16}}>
                      <input type="checkbox" id="pets" checked={form.hasPets} onChange={e => setForm(f => ({ ...f, hasPets: e.target.checked }))} style={{width:14,height:14,accentColor:accent}}/>
                      <label htmlFor="pets" style={{fontSize:12,color:'#4A4A4A',cursor:'pointer'}}>Guest has pets</label>
                    </div>
                  </div>
                </div>

                {/* Purpose & billing */}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                  <div>
                    <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:5}}>Purpose of Visit</label>
                    <input value={form.purpose} onChange={e => setForm(f => ({ ...f, purpose: e.target.value }))} placeholder="e.g. Summer research fellowship"
                      style={{width:'100%',padding:'8px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}/>
                  </div>
                  <div>
                    <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:5}}>Bill Charges To</label>
                    <input value={form.billTo} onChange={e => setForm(f => ({ ...f, billTo: e.target.value }))} placeholder="e.g. Grant #, Department"
                      style={{width:'100%',padding:'8px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}/>
                  </div>
                </div>

                <div>
                  <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:5}}>Additional Notes</label>
                  <textarea value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} rows={3}
                    placeholder="Any special requirements or context for this booking..."
                    style={{width:'100%',padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',resize:'vertical',color:'#2B2B2B'}}/>
                </div>

                <button onClick={handleSubmit}
                  style={{width:'100%',padding:'12px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                  Submit Booking Request →
                </button>
              </div>
            )}
          </div>

          {/* Summary card */}
          <div style={{display:'flex',flexDirection:'column',gap:12}}>
            {selectedSpace && (
              <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
                <div style={{height:6,background:typeColor[selectedSpace.type]}}/>
                <div style={{padding:'14px'}}>
                  <div style={{fontSize:10,color:typeColor[selectedSpace.type],fontWeight:600,textTransform:'uppercase',letterSpacing:'0.08em',marginBottom:4}}>{typeIcon[selectedSpace.type]} {selectedSpace.type}</div>
                  <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#2B2B2B',marginBottom:8}}>{selectedSpace.name}</div>
                  <div style={{display:'flex',flexWrap:'wrap',gap:4,marginBottom:10}}>
                    {selectedSpace.amenities.map(a => (
                      <span key={a} style={{fontSize:9,padding:'2px 7px',borderRadius:10,background:'#F7F2EB',color:'#6B7D6B'}}>{a}</span>
                    ))}
                  </div>
                  {nights > 0 && (
                    <div style={{background:'#F7F2EB',borderRadius:8,padding:'10px 12px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                      <span style={{fontSize:12,color:'#6B7D6B'}}>Duration</span>
                      <span style={{fontFamily:'Georgia,serif',fontSize:16,color:accent,fontWeight:700}}>{nights} <span style={{fontSize:11,color:'#8A9E8A',fontFamily:"'Montserrat',sans-serif",fontWeight:400}}>night{nights!==1?'s':''}</span></span>
                    </div>
                  )}
                </div>
              </div>
            )}
            <div style={{background:'#2B2B2B',borderRadius:10,padding:'14px'}}>
              <div style={{fontSize:11,fontWeight:600,color:'rgba(255,255,255,0.5)',marginBottom:8,textTransform:'uppercase',letterSpacing:'0.1em'}}>How it works</div>
              {['Submit your request with guest details','Campus Services reviews availability','You receive a confirmation or alternative','Guest is notified and added to the calendar'].map((s,i) => (
                <div key={i} style={{display:'flex',gap:8,marginBottom:8,alignItems:'flex-start'}}>
                  <div style={{width:18,height:18,borderRadius:'50%',background:accent,color:'#fff',fontSize:9,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:1}}>{i+1}</div>
                  <div style={{fontSize:11,color:'rgba(255,255,255,0.6)',lineHeight:1.5}}>{s}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

